import { Dispatch } from "redux";

import { EntitlementAction, EntitlementActionTypes } from "./Entilement";
import { EntitlementCRMInfo } from "@blacknut/javascript-sdk/dist";
import { getEntitlementCRMPriceInfo as apiGetEntitlementCRMPriceInfo } from "@blacknut/javascript-sdk/dist/api/getEntitlementCRMPriceInfo";
export const getEntitlementCRMPriceInfo = (options: {
  entitlementId: string;
  bundle?: boolean;
}) => {
  return (dispatch: Dispatch<EntitlementAction>) => {
    dispatch({ type: EntitlementActionTypes.ENTITLEMENT_GET_PRICE_INFO_CMR_REQUEST });
    return new Promise<EntitlementCRMInfo>((resolve, reject) => {
      apiGetEntitlementCRMPriceInfo(options).subscribe({
        next: (res) => {
          dispatch({
            type: EntitlementActionTypes.ENTITLEMENT_GET_PRICE_INFO_CMR_SUCCESS,
            entitlementId: options.entitlementId,
            info: res,
          });
          resolve(res);
        },
        error: (e) => {
          dispatch({
            type: EntitlementActionTypes.ENTITLEMENT_GET_PRICE_INFO_CMR_ERROR,
            entitlementId: options.entitlementId,
            error: e,
          });
          reject(e);
        },
      });
    });
  };
};
